import { clearGetException, getExceptionFail, getExceptionStarted, getExceptionSuccess } from '../../../reducer/services/GetExceptionReducer';
import { getException } from '../../actionType/services/ServiceActionTypes';
import { ClearGetException, GetExceptionFailure, GetExceptionFailurePayload, GetExceptionRequest, GetExceptionStarted, GetExceptionSuccess, GetExceptionSuccessPayload } from '../../types/exceptions/GetExceptionTypes';

export const getExceptionRequest = (reqObject: string | undefined): GetExceptionRequest => ({
  type: getException.GET_EXCEPTION_REQUEST,
  requestObject: reqObject,
});

/**
 * Fetch exception started saga action
 * @returns event started action
 */
export const getExceptionStart = (): GetExceptionStarted => ({
  type: getExceptionStarted.type
});

/**
 * Fetch exception success saga action
 * @param payload :Event data
 * @returns success action
 */
export const getExceptionSuccessful = (
  payload: GetExceptionSuccessPayload
): GetExceptionSuccess => ({
  type: getExceptionSuccess.type,
  payload
});

/**
 * Fetch Exception Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getExceptionFailure = (
  payload: GetExceptionFailurePayload
): GetExceptionFailure => ({
  type: getExceptionFail.type,
  payload
});

/**
 * Clear Exception saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearGetExceptionsDetails = (): ClearGetException => ({
  type: clearGetException.type
});
